<div id="st-point-breakdown-sidebar-container" class="sidebar-container">
  <header class="sidebar-header" [ngClass]="{'RankingAndRating_header': matchesViewMode === 'RankingAndRating'}">
    <div id="st-point-breakdown-header-content" class="header-content">
      <h2
        class="header-title-ellipsis"
        [pTooltip]="(('point_breakdown_for' | translate) + ' ' + (currentParticipantName || ''))"
        tooltipPosition="bottom"
        tooltipStyleClass="stupa-compact-tooltip"
      >
        {{ 'point_breakdown_for' | translate }} {{ currentParticipantName }}
      </h2>
    </div>
    <div id="st-point-breakdown-rankingandratingpoints" *ngIf="matchesViewMode === 'RankingAndRating'" class="Ranking_and_rating_points mt-2">Ello Points : <span>{{
        combinedElloPoints ?? 0 }}</span> <svg width="2" height="16" viewBox="0 0 2 16" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M1.23718 -0.000444174V15.5479H-3.32743e-05V-0.000444174H1.23718Z" fill="#979797" />
      </svg>
      Bonus points : <span>{{ combinedBonusPoints ?? 0 }}


      </span> <svg width="2" height="16" viewBox="0 0 2 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.23718 -0.000444174V15.5479H-3.32743e-05V-0.000444174H1.23718Z" fill="#979797" />
      </svg> Total Points : <span>{{ combinedOverallTotalPoints ?? 0
        }}</span></div>
    <button class="close-btn" (click)="onClose()" (keydown.enter)="onClose()" (keydown.space)="$event.preventDefault(); onClose()" tabindex="0">✖</button>
  </header>
  <div id="st-point-breakdown-sidebar-content" class="sidebar-content" (click)="$event.stopPropagation()" (keydown.enter)="$any($event).stopPropagation()" (keydown.space)="$event.preventDefault(); $any($event).stopPropagation()" *ngIf="!isLoading">
    <!-- Show matches template when showMatchesView is true -->
    <ng-container *ngIf="showMatchesView">
      <ng-container *ngIf="matchesViewMode === 'Ranking'; else combined_matches_outlet">
        <ng-container *ngTemplateOutlet="matches_template"></ng-container>
      </ng-container>
      <ng-template #combined_matches_outlet>
        <ng-container *ngTemplateOutlet="combined_matches_template"></ng-container>
      </ng-template>
    </ng-container>

    <!-- Show main breakdown view when showMatchesView is false -->
    <ng-container *ngIf="!showMatchesView">
      <div id="st-point-breakdown-points-note" class="points-note" *ngIf="matchesViewMode != 'RankingAndRating'">
        <span class="note-label">{{ 'note' | translate }}:</span> {{ 'highlighted_indicates_results' | translate }}
      </div>
      <ng-container *ngIf="leaderboardMode === 'Ranking'; else combined_breakdown_template">
        <div class="ranking-events-list">
        <div id="st-point-breakdown-event-points-container" class="event-points-container">
          <div id="st-point-breakdown-event-name" class="event-name">
            <h3>{{ 'event_name' | translate }}</h3>
          </div>
          <div id="st-point-breakdown-points" class="points">
            <h3>{{ 'points' | translate }}</h3>
          </div>
          <div class="edit-action">
            <h3>{{ 'action' | translate }}</h3>
          </div>
        </div>

        @if (eventPerformances.length === 0) {
          <p class="no-category-message">{{ 'no_event_performances_available' | translate }}</p>
        }

        @for (event of eventPerformances; track getEventTrackId(event, eventIndex); let eventIndex = $index) {
          <div
            [id]="'st-point-breakdown-event-points-data-' + getEventTrackId(event, eventIndex)"
            class="event-points-data"
            [class.event-points-data--highlighted]="event.is_highlighted"
          >
            <div class="data-row">
              <div class="event-data">
                <div class="event-title priority-name-wrap">
                  <span
                    class="priority-name-text"
                    [pTooltip]="event.event_name || ''"
                    tooltipPosition="bottom"
                    tooltipStyleClass="stupa-compact-tooltip"
                  >
                    {{ event.event_name }}
                  </span>
                  <span
                    *ngIf="hasPriorityBadge(event)"
                    [pTooltip]="'event_considered_in_total_points_calculation' | translate"
                    tooltipPosition="bottom"
                    tooltipStyleClass="stupa-compact-tooltip"
                    appendTo="body"
                    class="priority-badge"
                    [ngClass]="'priority-badge--' + getPriorityType(event)"
                  >
                    <span
                      class="priority-triangle"
                      [ngClass]="'priority-triangle--' + getPriorityType(event)"
                    ></span>
                    <span class="priority-badge-label">{{ getPriorityLabel(event) }}</span>
                  </span>
                  @if (isExternalEvent(event)) {
                    <span
                      class="external-event-badge"
                      [pTooltip]="'external_event_tooltip' | translate"
                      tooltipPosition="bottom"
                      tooltipStyleClass="stupa-external-event-tooltip"
                      appendTo="body"
                    >
                      {{ 'external_event_badge' | translate }}
                    </span>
                  }
                </div>
                <div class="event-dates">
                  @if (event.expiry_date) {
                    <span class="date-item">
                      <span>{{ 'expiry' | translate }}</span>: {{ event.expiry_date }}
                    </span>
                  }
                  @if (event.allocation_date) {
                    <span class="date-item">
                      <span>{{ 'allocation' | translate }}</span>: {{ event.allocation_date }}
                    </span>
                  }
                </div>
              </div>
              <button type="button" (click)="toggleBreakdown(event, $event, eventIndex)" (keydown.enter)="toggleBreakdown(event, $event, eventIndex)" (keydown.space)="toggleBreakdown(event, $event, eventIndex)" class="points-data" [attr.aria-expanded]="isMergedEvent(event) ? isMergedParentBreakdownExpanded(eventIndex) : selectedBreakdownEventId === event.event_id">
                <span class="points-value">{{ getEventDisplayPoints(event) }}</span>
              </button>
              <div class="edit-action-data">
                <button type="button" (click)="toggleBreakdown(event, $event, eventIndex)" (keydown.enter)="toggleBreakdown(event, $any($event), eventIndex)" (keydown.space)="$event.preventDefault(); toggleBreakdown(event, $any($event), eventIndex)"><img alt="" src="assets/ranking-rating_assets/edit_icon_breakdown.svg" [attr.alt]="'breakdown' | translate" class="edit-icon" /></button>
              </div>
            </div>

            @if (isMergedEvent(event) && isMergedParentBreakdownExpanded(eventIndex)) {
              <div class="breakdown merged-events-breakdown" @breakdownAnimation>
                <h4>{{ 'breakdown' | translate }}</h4>
                <div class="merged-events-list ranking-events-list">
                  @for (mergedEvent of getMergedEvents(event); track mergedEvent.event_id) {
                    <div
                      [id]="'st-point-breakdown-merged-event-' + mergedEvent.event_id"
                      class="event-points-data merged-event-points-data"
                      [class.event-points-data--highlighted]="mergedEvent.is_highlighted"
                    >
                      <div class="data-row">
                        <div class="event-data">
                          <div class="event-title priority-name-wrap">
                            <span
                              class="priority-name-text"
                              [pTooltip]="mergedEvent.event_name || ''"
                              tooltipPosition="bottom"
                              tooltipStyleClass="stupa-compact-tooltip"
                            >
                              {{ mergedEvent.event_name }}
                            </span>
                            @if (isExternalEvent(mergedEvent)) {
                              <span
                                class="external-event-badge"
                                [pTooltip]="'external_event_tooltip' | translate"
                                tooltipPosition="bottom"
                                tooltipStyleClass="stupa-external-event-tooltip"
                                appendTo="body"
                              >
                                {{ 'external_event_badge' | translate }}
                              </span>
                            }
                          </div>
                          <div class="event-dates">
                            @if (mergedEvent.expiry_date) {
                              <span class="date-item">
                                <span>{{ 'expiry' | translate }}</span>: {{ mergedEvent.expiry_date }}
                              </span>
                            }
                            @if (mergedEvent.allocation_date) {
                              <span class="date-item">
                                <span>{{ 'allocation' | translate }}</span>: {{ mergedEvent.allocation_date }}
                              </span>
                            }
                          </div>
                        </div>
                        <button type="button" (click)="toggleMergedSubEventBreakdown(mergedEvent, $event)" (keydown.enter)="toggleMergedSubEventBreakdown(mergedEvent, $event)" (keydown.space)="toggleMergedSubEventBreakdown(mergedEvent, $event)" class="points-data" [attr.aria-expanded]="isMergedSubEventBreakdownExpanded(mergedEvent)">
                          <span class="points-value">{{ getEventDisplayPoints(mergedEvent) }}</span>
                        </button>
                        <div class="edit-action-data">
                          <button type="button" (click)="toggleMergedSubEventBreakdown(mergedEvent, $event)" (keydown.enter)="toggleMergedSubEventBreakdown(mergedEvent, $any($event))" (keydown.space)="$event.preventDefault(); toggleMergedSubEventBreakdown(mergedEvent, $any($event))"><img alt="" src="assets/ranking-rating_assets/edit_icon_breakdown.svg" [attr.alt]="'breakdown' | translate" class="edit-icon" /></button>
                        </div>
                      </div>

                      @if (isMergedSubEventBreakdownExpanded(mergedEvent)) {
                        <ng-container
                          *ngTemplateOutlet="categoryBreakdownContent; context: { breakdownEvent: mergedEvent }"
                        ></ng-container>
                      }
                    </div>
                  }
                </div>
              </div>
            } @else if (!isMergedEvent(event) && selectedBreakdownEventId === event.event_id) {
              <ng-container
                *ngTemplateOutlet="categoryBreakdownContent; context: { breakdownEvent: event }"
              ></ng-container>
            }
          </div>
        }
        </div>
      </ng-container>

      <ng-template #categoryBreakdownContent let-breakdownEvent="breakdownEvent">
        <div class="breakdown" @breakdownAnimation>
          <h4>{{ 'breakdown' | translate }}</h4>

          @if (getCategoryBreakdown(breakdownEvent).length > 0) {
            <div class="category-breakdown-list">
              @for (category of getCategoryBreakdown(breakdownEvent); track category.category_id + '-' + category.participant_type_id) {
                <div
                  class="category-breakdown-item"
                  [class.category-breakdown-item--expanded]="isCategoryBreakdownExpanded(breakdownEvent, category)"
                >
                  <button type="button" (click)="onCategoryBreakdownClick($event, breakdownEvent, category)" (keydown.enter)="onCategoryBreakdownClick($event, breakdownEvent, category)" (keydown.space)="onCategoryBreakdownClick($event, breakdownEvent, category)" class="category-breakdown-row" [class.category-breakdown-row--expanded]="isCategoryBreakdownExpanded(breakdownEvent, category)" [attr.aria-expanded]="isCategoryBreakdownExpanded(breakdownEvent, category)">
                    <div class="category-breakdown-labels">
                      @if (getCategoryLevelName(category)) {
                        <span class="category-breakdown-level">{{ getCategoryLevelName(category) }}</span>
                      }
                      <span class="category-breakdown-name">{{ category.category_name }}</span>
                      @if (getParticipantTypeChip(category)) {
                        <span class="category-breakdown-chip">{{ getParticipantTypeChip(category) }}</span>
                      }
                    </div>
                    <div class="category-breakdown-meta">
                      <span
                        class="category-breakdown-chevron"
                        [class.category-breakdown-chevron--open]="isCategoryBreakdownExpanded(breakdownEvent, category)"
                        aria-hidden="true"
                      ></span>
                    </div>
                  </button>

                  @if (isCategoryBreakdownExpanded(breakdownEvent, category)) {
                    <div class="category-breakdown-accordion" @breakdownAnimation>
                      @if (breakdownEvent.event_id !== null && isCategorySummaryLoading(breakdownEvent.event_id, category.category_id)) {
                        <div class="category-breakdown-loader">
                          <stupa-skeleton-loader [rows]="3" [columns]="3" />
                        </div>
                      } @else if (getExpandedCategoryPointRows(breakdownEvent, category).length > 0) {
                        <div class="point-breakdown-container ranking_container1">
                          @for (row of getExpandedCategoryPointRows(breakdownEvent, category); track row.translationKey) {
                            <button type="button" (click)="onExpandedCategoryPointRowClick($event, breakdownEvent, category, row)" (keydown.enter)="onExpandedCategoryPointRowClick($any($event), breakdownEvent, category, row)" (keydown.space)="$event.preventDefault(); onExpandedCategoryPointRowClick($any($event), breakdownEvent, category, row)" class="point-breakdown-item" [class.point-breakdown-item--clickable]="row.clickable">
                              <span class="point-name">{{ row.translationKey | translate }}</span>
                              @if (row.translationKey === 'based_on_position' && row.tournamentWeight) {
                                <span class="tw">
                                  {{ row.tournamentWeight }}
                                  <span>({{ 'tournament_weight_short' | translate }})</span>
                                </span>
                              }
                              <span class="point-value">{{ row.value }}</span>
                            </button>
                          }
                        </div>
                      } @else {
                        <div class="point-breakdown-container ranking_container1">
                          <div class="point-breakdown-item">
                            <span class="point-name">{{ 'points' | translate }}</span>
                            <span class="point-value">{{ category.points }}</span>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          } @else if (breakdownEvent.event_id !== null && isEventBreakdownLoading(breakdownEvent.event_id)) {
            <div class="breakdown-loader">
              <stupa-skeleton-loader [rows]="3" [columns]="3" />
            </div>
          } @else if (mappedBreakdownDetails.length > 0) {
            <div class="point-breakdown-container">
              @for (component of mappedBreakdownDetails; track component.heading) {
                <button type="button" (click)="onPointClick(component.heading)" (keydown.enter)="onPointClick(component.heading)" (keydown.space)="$event.preventDefault(); onPointClick(component.heading)" class="point-breakdown-item">
                  <span class="point-name">{{ component.heading }}</span>
                  <span class="point-value">{{ component.points }}</span>
                </button>
              }
            </div>
          } @else {
            <p class="no-category-message">{{ 'no_breakdown_details_available' | translate }}</p>
          }
        </div>
      </ng-template>

      <ng-template #combined_breakdown_template>
        <div id="st-point-breakdown-combined-header" class="combined-header">
          <div id="st-point-breakdown-combined-header-left" class="combined-header-left">
            {{ 'tournament_name' | translate }}
          </div>
          <div id="st-point-breakdown-combined-header-center" class="combined-header-center">
            <div id="st-point-breakdown-elo-pill" class="elo-pill">Elo Point</div>
            <div id="st-point-breakdown-elo-columns" class="elo-columns">
              <span>{{ 'initial' | translate }}</span>
              <span>{{ 'delta' | translate }}</span>
              <span>{{ 'final' | translate }}</span>
            </div>
          </div>
          <div id="st-point-breakdown-combined-header-right" class="combined-header-right">
            {{ 'bonus_pts' | translate }}
          </div>
        </div>

        <p-accordion [activeIndex]="activeCombinedEventIndex"
          (activeIndexChange)="onCombinedEventAccordionIndexChange($event)" [multiple]="false">
          <p-accordionTab *ngFor="let ev of combinedEvents; let eidx = index; trackBy: trackById">
            <ng-template pTemplate="header">
              <div id="st-point-breakdown-combined-event-card" class="combined-event-card" style="cursor: pointer;">
                <div id="st-point-breakdown-combined-event-main" class="combined-event-main">
                  <div id="st-point-breakdown-priority-name-wrap-3" class="priority-name-wrap">
                    <span
                      class="combined-event-title priority-name-text"
                      [pTooltip]="ev.event_name || ''"
                      tooltipPosition="bottom"
                      tooltipStyleClass="stupa-compact-tooltip"
                    >
                      {{ ev.event_name }}
                    </span>
                    <span
                      *ngIf="hasPriorityBadge(ev)"
                      [pTooltip]="'event_considered_in_total_points_calculation' | translate"
                      tooltipPosition="bottom"
                      tooltipStyleClass="stupa-compact-tooltip"
                      appendTo="body"
                      class="priority-badge"
                      [ngClass]="'priority-badge--' + getPriorityType(ev)"
                    >
                      <span
                        class="priority-triangle"
                        [ngClass]="'priority-triangle--' + getPriorityType(ev)"
                      ></span>
                      <span class="priority-badge-label">{{ getPriorityLabel(ev) }}</span>
                    </span>
                    @if (isExternalEvent(ev)) {
                      <span
                        class="external-event-badge"
                        [pTooltip]="'external_event_tooltip' | translate"
                        tooltipPosition="bottom"
                        tooltipStyleClass="stupa-external-event-tooltip"
                        appendTo="body"
                      >
                        {{ 'external_event_badge' | translate }}
                      </span>
                    }
                  </div>
                  <div id="st-point-breakdown-combined-event-meta" class="combined-event-meta">
                    <span class="combined-date-label">Date {{ ev.event_date || '-' }}</span>
                  </div>
                </div>
                <div id="st-point-breakdown-combined-elo-values" class="combined-elo-values">
                  <span class="elo-value">{{ ev.rating_initial ?? '-' }}</span>
                  <span class="elo-value" [ngClass]="getEventRatingDeltaClass(ev)">{{ getEventRatingDeltaDisplay(ev)
                    }}</span>
                  <span class="elo-value">{{ ev.rating_final ?? '-' }}</span>
                </div>
                <div id="st-point-breakdown-combined-bonus" class="combined-bonus">
                  <span class="combined-bonus-label">{{ 'bonus_pts' | translate }}</span>
                  <span class="elo-value">{{ ev.bonus_points ?? 0 }}</span>
                </div>
              </div>
            </ng-template>

            <ng-template pTemplate="content">
              <div id="st-point-breakdown-combined-category-wrapper" class="combined-category-wrapper">
                <button type="button" (click)="openCombinedCategoryMatches(ev, cat)" (keydown.enter)="openCombinedCategoryMatches(ev, cat)" (keydown.space)="$event.preventDefault(); openCombinedCategoryMatches(ev, cat)" *ngFor="let cat of (ev.categories || []); trackBy: trackById" [id]="'st-point-breakdown-combined-category-card' + (cat)" class="combined-category-card">
                  <div id="st-point-breakdown-combined-category-title" class="combined-category-title mx-2">
                    {{ cat.category_name }}
                  </div>
                  <div id="st-point-breakdown-combined-category-row" class="combined-category-row">
                    <span class="label">
                      {{ 'victory_points' | translate }}
                    </span>
                    <span class="value">
                      {{ cat.bonus_points ?? 0 }}
                    </span>
                  </div>
                </button>
                <div id="st-point-breakdown-no-matches-message" *ngIf="!ev.categories || ev.categories.length === 0" class="no-matches-message">
                  <p>{{ 'no_data_available' | translate }}</p>
                </div>
              </div>
            </ng-template>
          </p-accordionTab>
        </p-accordion>
      </ng-template>
    </ng-container>




    <ng-container *ngIf="false">
      <div id="st-point-breakdown-loader-container" *ngIf="isLoading" class="loader-container">
        
      </div>
      <div id="st-point-breakdown-event-points-data" *ngIf="!isLoading && eventPerformances.length === 0" class="event-points-data">
        <p>{{ 'no_event_performances_available' | translate }}</p>
      </div>
      <div [id]="'st-point-breakdown-event-points-data-4' + (event)" *ngFor="let event of eventPerformances; trackBy: trackById" class="event-points-data"
        [style.backgroundColor]="event.is_highlighted ? '#F4FAFF' : '#FFFFFF'">
        <div id="st-point-breakdown-data-row" class="data-row">
          <div id="st-point-breakdown-event-data" class="event-data">
            <div id="st-point-breakdown-event-title" class="event-title">{{ event.event_name }}</div>
            <div id="st-point-breakdown-event-dates" class="event-dates">
              <span class="date-item">{{ 'expiry' | translate }}: {{ event.expiry_date }}</span>
              <span class="date-item">{{ 'allocation' | translate }}: {{ event.allocation_date }}</span>
            </div>
          </div>
          <div id="st-point-breakdown-points-data" class="points-data">
            <span class="points-value">{{ event.points }}</span>
          </div>
          
        </div>
        <div id="st-point-breakdown-breakdown" class="breakdown" *ngIf="selectedBreakdownEventId === event.event_id" @breakdownAnimation>
          <h4>{{ 'breakdown' | translate }}</h4>
          <div id="st-point-breakdown-loader-container-5" *ngIf="isLoading" class="loader-container">
            
          </div>
          <div id="st-point-breakdown-point-breakdown-container" *ngIf="!isLoading && mappedBreakdownDetails.length > 0" class="point-breakdown-container">
            <button type="button" (click)="onPointClick(component.heading)" (keydown.enter)="onPointClick(component.heading)" (keydown.space)="$event.preventDefault(); onPointClick(component.heading)" *ngFor="let component of mappedBreakdownDetails; trackBy: trackById" [id]="'st-point-breakdown-point-breakdown-item' + (component)" class="point-breakdown-item">
              <span class="point-name">{{ component.heading }}</span>
              <span class="point-value">{{ component.points }} {{ 'points' | translate | lowercase}}</span>
            </button>
          </div>
          <div id="st-point-breakdown-block-6" *ngIf="!isLoading && mappedBreakdownDetails.length === 0">
            <p>{{ 'no_breakdown_details_available' | translate }}</p>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <div id="st-point-breakdown-block-7" class="p-3" *ngIf="isLoading">
    <stupa-skeleton-loader [rows]="8" [columns]="3" />
  </div>
  <div id="st-point-breakdown-sidebar-footer" class="sidebar-footer" *ngIf="!isLoading">
    
    <div id="st-point-breakdown-footer-right-buttons" class="footer-right-buttons">
      
      <button class="publish-btn" (click)="onClose()" (keydown.enter)="onClose()" (keydown.space)="$event.preventDefault(); onClose()" tabindex="0">{{ 'close' | translate }}</button>
    </div>
  </div>
  <stupa-expired-points *ngIf="showExpiredPoints" (panelClose)="toggleExpiredPoints()" [participantId]="participantId"
    [categoryId]="categoryId"></stupa-expired-points>
  <p-dialog [focusOnShow]="false" class="ranking-rating-popup" [modal]="true" [(visible)]="showPausePopup" [draggable]="false"
    [resizable]="false" [showHeader]="false" [style]="{ width: '26.25rem', height: '15rem' }">
    <button type="button" class="popup-custom-close-button" (click)="closePausePopup()" (keydown.enter)="closePausePopup()" (keydown.space)="$event.preventDefault(); closePausePopup()" aria-label="Close" tabindex="0">
      ×
    </button>
    <div id="st-point-breakdown-dialog-content" class="dialog-content text-center mb-3">
      <div id="st-point-breakdown-dialog-title-block" class="dialog-title-block">
        <p style="font-size: 16px; font-weight: 500; margin-bottom: 0">
          {{ 'do_you_want_to' | translate }} {{ isPaused ? ('unpause' | translate) : ('pause_lowercase' | translate) }}
          {{ 'ranking_for' | translate }} "{{
          participantName
          }}"?
        </p>
      </div>
      <p class="mt-3" style="font-size: 12px; color: #9d9d9d">
        {{
        isPaused
        ? ('deactivating_feature_message' | translate)
        : ('activating_feature_message' | translate)
        }}
      </p>
      <div id="st-point-breakdown-block-8" class="d-flex justify-content-center gap-3 mt-3">
        <button (click)="closePausePopup()" (keydown.enter)="closePausePopup()" (keydown.space)="$event.preventDefault(); closePausePopup()" class="settings-btn" tabindex="0">{{ 'cancel' | translate }}</button>
        <button (click)="confirmPause()" (keydown.enter)="confirmPause()" (keydown.space)="$event.preventDefault(); confirmPause()" class="create-btn" tabindex="0">{{ 'confirm' | translate }}</button>
      </div>
    </div>
  </p-dialog>
</div>



<ng-template #award_points_template let-item="item">
  <div id="st-point-breakdown-accordian-padding" class="accordian-padding">
    <div id="st-point-breakdown-award-points-container" class="award-points-container">
      <div id="st-point-breakdown-categoryname" class="category_name">{{ item.category_name }}</div>
      @for(eventItem of item.events_breakdown ?? []; track eventItem?.event_id; let eventIndex = $index){
      @for(stage of eventItem?.stages ?? []; track stage?.stage_id; let stageIndex = $index){

      @for(pointItem of getEventPointSummaryItems(eventItem?.event_point_summary); track pointItem.heading +
      pointItem.value){
      <div [id]="'st-point-breakdown-award-points-item' + (stageIndex)" class="award-points-item d-flex justify-content-between align-items-center">
        <p class="m-0">{{ pointItem.heading }}</p>
        <button type="button" (click)="onEventPointValueClick($event, pointItem, eventItem, stage?.stage_id, stage?.stage_name)" (keydown.enter)="onEventPointValueClick($any($event), pointItem, eventItem, stage?.stage_id, stage?.stage_name)" (keydown.space)="$event.preventDefault(); onEventPointValueClick($any($event), pointItem, eventItem, stage?.stage_id, stage?.stage_name)" class="m-0 points_value" [ngClass]="{
                'text-danger': pointItem.heading === 'Penality points', 
                'text-victory': pointItem.heading === 'Victory points',
                'victory-clickable': pointItem.heading === 'Victory points'
              }" [style.text-decoration]="pointItem.heading === 'Victory points' ? 'underline' : 'none'" [style.cursor]="pointItem.heading === 'Victory points' ? 'pointer' : 'default'">
          {{ pointItem.value }}
        </button>
      </div>
      }

      }
      }
    </div>
  </div>
</ng-template>

<ng-template #combined_matches_template>
  <div id="st-point-breakdown-matches-view-container" class="matches-view-container">
    <div id="st-point-breakdown-matches-header" class="matches-header d-flex justify-content-between align-items-center mb-3">
      <h3 class="m-0">{{ combinedCurrentEventName }} - {{ combinedCurrentCategoryName }}</h3>
      <button class="back-btn" (click)="goBackToCombinedCategories()" (keydown.enter)="goBackToCombinedCategories()" (keydown.space)="$event.preventDefault(); goBackToCombinedCategories()" tabindex="0">
        ← {{ 'back' | translate }}
      </button>
    </div>
    <div id="st-point-breakdown-combined-header-9" class="combined-header">
      <div id="st-point-breakdown-combined-header-left-10" class="combined-header-left">
        {{ 'tournament_name' | translate }}
      </div>
      <div id="st-point-breakdown-combined-header-center-11" class="combined-header-center">
        <div id="st-point-breakdown-elo-pill-12" class="elo-pill">{{ 'elo_point' | translate }}</div>
        <div id="st-point-breakdown-elo-columns-13" class="elo-columns">
          <span>{{ 'initial' | translate }}</span>
          <span>{{ 'delta' | translate }}</span>
          <span>{{ 'final' | translate }}</span>
        </div>
      </div>
      <div id="st-point-breakdown-combined-header-right-14" class="combined-header-right">
        {{ 'bonus_pts' | translate }}
      </div>
    </div>
    <div id="st-point-breakdown-combined-event-card-15" class="combined-event-card side_content mb-2">
      <div id="st-point-breakdown-combined-event-main-16" class="combined-event-main">
        <div id="st-point-breakdown-priority-name-wrap-17" class="priority-name-wrap">
          <span
            class="combined-event-title priority-name-text"
            [pTooltip]="combinedCurrentEventName || ''"
            tooltipPosition="bottom"
            tooltipStyleClass="stupa-compact-tooltip"
          >
            {{ combinedCurrentEventName }}
          </span>
          <span
            *ngIf="hasPriorityBadge(combinedCurrentEvent)"
            [pTooltip]="'event_considered_in_total_points_calculation' | translate"
            tooltipPosition="bottom"
            tooltipStyleClass="stupa-compact-tooltip"
            appendTo="body"
            class="priority-badge"
            [ngClass]="'priority-badge--' + getPriorityType(combinedCurrentEvent)"
          >
            <span  
              class="priority-triangle"
              [ngClass]="'priority-triangle--' + getPriorityType(combinedCurrentEvent)"
            ></span>
            <span class="priority-badge-label">{{ getPriorityLabel(combinedCurrentEvent) }}</span>
          </span>
          @if (isExternalEvent(combinedCurrentEvent)) {
            <span
              class="external-event-badge"
              [pTooltip]="'external_event_tooltip' | translate"
              tooltipPosition="bottom"
              tooltipStyleClass="stupa-external-event-tooltip"
              appendTo="body"
            >
              {{ 'external_event_badge' | translate }}
            </span>
          }
        </div>
        <div id="st-point-breakdown-combined-event-meta-18" class="combined-event-meta">
          <span class="combined-date-label side_date">Date {{ combinedMatchEventDate || '-' }}</span>
        </div>
      </div>
      <div id="st-point-breakdown-combined-elo-values-19" class="combined-elo-values">
        <span class="elo-value">{{ combinedMatchRatingInitial ?? '-' }}</span>
        <span class="elo-value" [ngClass]="getCombinedMatchRatingDeltaClass()">{{ getCombinedMatchRatingDeltaDisplay() }}</span>
        <span class="elo-value">{{ combinedMatchRatingFinal ?? '-' }}</span>
      </div>
      <div id="st-point-breakdown-combined-bonus-20" class="combined-bonus">
        <span class="combined-bonus-label">{{ 'bonus_pts' | translate }}</span>
        <span class="elo-value">{{ combinedMatchBonusPoints ?? 0 }}</span>
      </div>
    </div>
    <div id="st-point-breakdown-tournamentcontainer" class="tournament_container">
      @if(combined_matches_list && combined_matches_list.length > 0) {
      <div id="st-point-breakdown-combined-matches-table-scroll" class="matches-table-scroll">
        <div id="st-point-breakdown-combined-matches-table" class="matches-table matches-table--5">
          <div id="st-point-breakdown-matches-table-header" class="matches-table-header">
            <button type="button" (click)="onCombinedMatchesSort('status')" (keydown.enter)="onCombinedMatchesSort('status')" (keydown.space)="$event.preventDefault(); onCombinedMatchesSort('status')" id="st-point-breakdown-header" class="header sortable">
              {{ 'status' | translate }}
            </button>
            <button type="button" (click)="onCombinedMatchesSort('opponent_name')" (keydown.enter)="onCombinedMatchesSort('opponent_name')" (keydown.space)="$event.preventDefault(); onCombinedMatchesSort('opponent_name')" id="st-point-breakdown-header-21" class="header sortable">
              {{ 'opponent_name' | translate }}
            </button>
            <button type="button" (click)="onCombinedMatchesSort('date')" (keydown.enter)="onCombinedMatchesSort('date')" (keydown.space)="$event.preventDefault(); onCombinedMatchesSort('date')" id="st-point-breakdown-header-22" class="header sortable">
              {{ 'date' | translate }}
            </button>
            <button type="button" (click)="onCombinedMatchesSort('score')" (keydown.enter)="onCombinedMatchesSort('score')" (keydown.space)="$event.preventDefault(); onCombinedMatchesSort('score')" id="st-point-breakdown-header-23" class="header sortable">
              {{ 'score' | translate }}
            </button>
            <button type="button" (click)="onCombinedMatchesSort('exchange')" (keydown.enter)="onCombinedMatchesSort('exchange')" (keydown.space)="$event.preventDefault(); onCombinedMatchesSort('exchange')" id="st-point-breakdown-header-24" class="header sortable">
              {{ 'exchange' | translate }}
            </button>
          </div>
          @for(match of sortedCombinedMatches; track match.match_id; let matchIndex = $index){
          <div [id]="'st-point-breakdown-matches-table-row' + (match.match_id)" class="matches-table-row">
            <div [id]="'st-point-breakdown-status' + (match.match_id)" class="status">
              <span class="status-badge">{{getCombinedStatus(match)}}</span>
            </div>
            <div [id]="'st-point-breakdown-name' + (match.match_id)" class="name">
              <span
                class="name-ellipsis"
                [pTooltip]="getCombinedOpponentName(match) || ''"
                tooltipPosition="bottom"
                tooltipStyleClass="stupa-compact-tooltip"
              >
                {{getCombinedOpponentName(match)}}
              </span>
            </div>
            <div [id]="'st-point-breakdown-date' + (match.match_id)" class="date">{{getCombinedMatchDate(match)}}</div>
            <div [id]="'st-point-breakdown-score' + (match.match_id)" class="score">
              @if(getCombinedScore(match)) {
              <span class="value-badge">{{getCombinedScore(match)}}</span>
              }
            </div>
            <div [id]="'st-point-breakdown-vp' + (match.match_id)" class="vp">
              @if(getCombinedRatingExchangeDisplay(match)) {
              <span class="value-badge"
                [ngClass]="getCombinedRatingExchangeClass(match)">{{getCombinedRatingExchangeDisplay(match)}}</span>
              }
            </div>
          </div>
          }
          <div id="st-point-breakdown-matches-table-total" class="matches-table-total">
            <div id="st-point-breakdown-total-label" class="total-label">{{ 'total' | translate }}</div>
            <div id="st-point-breakdown-total-value" class="total-value">
              <span class="total-points">{{ combinedTotalPoints ?? 0 }}</span>
              <span class="total-unit">{{ 'pts' | translate | lowercase}}</span>
            </div>
          </div>
        </div>
      </div>
      } @else {
      <div id="st-point-breakdown-no-matches-message-28" class="no-matches-message">
        <p>{{ 'no_matches_found_for_stage' | translate }}</p>
      </div>
      }
    </div>
  </div>
</ng-template>
<ng-template #stage_points_inner_template let-event="event" let-index="index" let-stages_break_down="stages_break_down">

  <ng-container *ngIf="!stageLoading">
    @for(eventItem of stages_break_down ?? []; track eventItem?.event_id; let eventIndex = $index){
    @for(stage of eventItem?.stages ?? []; track stage?.stage_id; let stageIndex = $index){
    <div [id]="'st-point-breakdown-stage-points-container' + stageIndex" class="stage-points-container mt-1">
      <div [id]="'st-point-breakdown-categoryname-29' + stageIndex" class="category_name"><span style="margin-right: 0.5rem;">S{{stageIndex + 1}} </span> {{stage?.stage_name}}
      </div>
      @for(pointItem of getStagePointSummaryItems(eventItem?.event_point_summary); track pointItem.heading +
      pointItem.value){
      <div [id]="'st-point-breakdown-stage-points-item' + (stageIndex)" class="stage-points-item d-flex justify-content-between align-items-center">
        <p class="m-0">{{pointItem.heading}}</p>
        <button type="button" (click)="onPointValueClick($event, pointItem, stage?.stage_id, stage?.matches_breakdown, stage?.stage_name)" (keydown.enter)="onPointValueClick($any($event), pointItem, stage?.stage_id, stage?.matches_breakdown, stage?.stage_name)" (keydown.space)="$event.preventDefault(); onPointValueClick($any($event), pointItem, stage?.stage_id, stage?.matches_breakdown, stage?.stage_name)" class="m-0 points_value" [ngClass]="{
          'text-danger': pointItem.heading === 'Penality points', 
          'text-victory': pointItem.heading === 'Victory points',
          'victory-clickable': pointItem.heading === 'Victory points'
        }" [style.text-decoration]="pointItem.heading === 'Victory points' ? 'underline' : 'none'" [style.cursor]="pointItem.heading === 'Victory points' ? 'pointer' : 'default'">
          {{pointItem.value}}</button>
      </div>
      }
    </div>
    }
    }
  </ng-container>
  <ng-container *ngIf="stageLoading">
    <div id="st-point-breakdown-block-30" class="h-100 d-flex align-items-center justify-content-center">
      <stupa-skeleton-loader class="p-3" [rows]="6" [columns]="3" />
    </div>
  </ng-container>
</ng-template>


<ng-template #stage_points_template let-event="event" let-categoryEntry="categoryEntry">
  <div id="st-point-breakdown-stageaccordian" class="stage_accordian">
    <p-accordion
      [activeIndex]="isAccordionOpen(event?.event_id, categoryEntry?.value?.category_id || event?.category_id) ? 0 : null"
      (activeIndexChange)="onAccordionIndexChange($event, categoryEntry?.value || event, categoryEntry?.key, event?.event_id, categoryEntry?.value?.category_id || event?.category_id)">
      <p-accordionTab>
        <ng-template pTemplate="header">

          <div id="st-point-breakdown-stageaccordionheader" class="d-flex justify-content-between align-items-center w-100 stage_accordion_header">

            <div id="st-point-breakdown-block-31" class="d-flex justify-content-between align-items-center">
              <div id="st-point-breakdown-tournamentname" class="tournament_name fw-bold">{{categoryEntry?.value?.category_name || event?.category_name}}
              </div>

            </div>
            <div id="st-point-breakdown-accordion-chevron" class="accordion-chevron">
              <span
                *ngIf="isAccordionOpen(event?.event_id, categoryEntry?.value?.category_id || event?.category_id)">▲</span>
              <span
                *ngIf="!isAccordionOpen(event?.event_id, categoryEntry?.value?.category_id || event?.category_id)">▼</span>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="content">
          @for(item of breakdownDetailsList ; track item; let index = $index){

          <ng-container
            *ngTemplateOutlet="stage_points_inner_template; context: { event: item, index: index,stages_break_down: item.events_breakdown }">

          </ng-container>
          }
        </ng-template>



      </p-accordionTab>

    </p-accordion>
  </div>

</ng-template>


<ng-template #matches_template>
  <div id="st-point-breakdown-matches-view-container-32" class="matches-view-container">
    <div id="st-point-breakdown-matches-header-33" class="matches-header d-flex justify-content-between align-items-center mb-3">
      <h3 class="m-0">{{ currentStageName }} - {{ 'match_history' | translate }}</h3>
      <button class="back-btn" (click)="goBackToBreakdown()" (keydown.enter)="goBackToBreakdown()" (keydown.space)="$event.preventDefault(); goBackToBreakdown()" tabindex="0">
        ← {{ 'back' | translate }}
      </button>
    </div>
    <div id="st-point-breakdown-tournamentcontainer-34" class="tournament_container">
      @if(matches_list && matches_list.length > 0) {
      <div id="st-point-breakdown-matches-table-scroll" class="matches-table-scroll">
        <div id="st-point-breakdown-matches-table" class="matches-table matches-table--7">
          <div id="st-point-breakdown-matches-table-header-35" class="matches-table-header">
            <div id="st-point-breakdown-header-36" class="header">{{ 'status' | translate }}</div>
            <div id="st-point-breakdown-header-37" class="header">{{ 'name' | translate }}</div>
            <div id="st-point-breakdown-header-38" class="header">{{ 'date' | translate }}</div>
            <div id="st-point-breakdown-header-39" class="header">{{ 'score' | translate }}</div>
            <div id="st-point-breakdown-header-40" class="header">{{ 'position' | translate }}</div>
            <div id="st-point-breakdown-header-41" class="header">{{ 'vp' | translate }}</div>
            <div id="st-point-breakdown-header-42" class="header">{{ 'bp' | translate }}</div>
          </div>
          @for(match of matches_list; track match.match_id; let matchIndex = $index){
          <div [id]="'st-point-breakdown-matches-table-row-43' + (match.match_id)" class="matches-table-row">
            <div [id]="'st-point-breakdown-status-44' + (match.match_id)" class="status">
              <span class="status-badge">{{match.match_status ?? null}}</span>
            </div>
            <div [id]="'st-point-breakdown-name-45' + (match.match_id)" class="name">
              <span
                class="name-ellipsis"
                [pTooltip]="match.opponent_name || ''"
                tooltipPosition="bottom"
                tooltipStyleClass="stupa-compact-tooltip"
              >
                {{match.opponent_name ?? null}}
              </span>
            </div>
            <div [id]="'st-point-breakdown-date-46' + (match.match_id)" class="date">{{getMatchDate(match) || '-'}}</div>
            <div [id]="'st-point-breakdown-score-47' + (match.match_id)" class="score">
              @if(match.match_score) {
              <span class="value-badge">{{match.match_score}}</span>
              } @else {
              <span class="value-badge value-badge--empty">-</span>
              }
            </div>
            <div [id]="'st-point-breakdown-block-48' + (match.match_id)" class="position">
              <span class="value-badge">{{getMatchPosition(match)}}</span>
            </div>
            <div [id]="'st-point-breakdown-vp-49' + (match.match_id)" class="vp">
              @if(getVictoryPoints(match) !== null) {
              <span class="value-badge">{{getVictoryPoints(match)}}</span>
              } @else {
              <span class="value-badge value-badge--empty">-</span>
              }
            </div>
            <div [id]="'st-point-breakdown-bp' + (match.match_id)" class="bp">
              @if(getBonusPoints(match) !== null) {
              <span class="value-badge">{{getBonusPoints(match)}}</span>
              } @else {
              <span class="value-badge value-badge--empty">-</span>
              }
            </div>
          </div>
          }
          <div id="st-point-breakdown-matches-table-total-50" class="matches-table-total">
            <div id="st-point-breakdown-total-label-51" class="total-label">{{ 'total' | translate }}</div>
            <div id="st-point-breakdown-total-value-57" class="total-value">
              <span class="total-points">{{getTotalPoints()}}</span>
              <span class="total-unit">{{ 'pts' | translate | lowercase}}</span>
            </div>
          </div>
        </div>
      </div>
      } @else {
      <div id="st-point-breakdown-no-matches-message-58" class="no-matches-message">
        <p>{{ 'no_matches_found_for_stage' | translate }}</p>
      </div>
      }
    </div>
  </div>
</ng-template>